import React from 'react'
import { Box, Button, Grid, Typography } from '@mui/material';
import { observer, useLocalObservable } from 'mobx-react-lite'
import AuthorizationData from './authorization-data';
import CommonInput from '../../../component/form/common-input.component';
import i18n from '../../../i18n';
import ButtonComponent from '../../../component/button/button.component';
import CardView from '../../../component/card/card-view';
import { AuthCardGroup } from './auth-card';
import DeleteDialog from '../../../component/dialog/delete-dialog.component';
import { AuthPointDialog } from './auth-point-dialog';
import { useTranslation } from 'react-i18next';
import { AuthPointInfoDialog } from './auth-point-info-dialog';
import './scss/authorization-manager.style.scss'
import { ConditionType, ConditionsBox, SearchKeyInput, SearchKeyInputItems } from '../../../component/form/search-key-input.component';
import { toJS } from 'mobx';

const AuthorizationManager = observer((
    props: {
        comType: 'GROUP' | 'RESTAURANT';
        restaurantStringId?: string;
    }
) => {
    useTranslation();
    const useData = useLocalObservable(() => new AuthorizationData());
    const { belongedGroupName, searchSecondKey, searchSort, isPatchFlag, viewMode, groupWarrantList,
        restuarantWarrantList, selectedList, authPointDialogData, confirmDialogData, authPointInfoDialogData,
        belongedGroup, comType, isLoading, activeType, conditions
    } = useData;
    // 搜索key
    const searchKeyListGroup = [
        { value: 'name', label: i18n.t('warrant_page_text_authorization_scheme'), type: 'TEXT' },
        { value: 'nickname', label: i18n.t('warrant_page_text_restaurant_name'), type: 'TEXT' }
    ]
    // 搜索key
    const searchKeyListRes = [
        { value: 'name', label: i18n.t('warrant_page_text_authorization_scheme'), type: 'TEXT' },
    ]
    // 视图模式
    const viewModeList = [
        { value: 'DETAIL', label: i18n.t('warrant_page_button_detailed_mode') },
        { value: 'SUMMARY', label: i18n.t('warrant_page_button_summary_mode') }
    ]
    // 授权激活筛选
    const activeWarrantList = [
        { value: 'USE', label: i18n.t('warrant_page_text_activated_default') },
        { value: 'INACTIVATED', label: i18n.t('warrant_page_text_deactivated_default') },
        { value: 'EXPIRED', label: i18n.t('warrant_page_text_have_expired') }
    ]
    // 搜索key - 按时间
    const searchKeySecondList = [
        { value: 'DATE', label: i18n.t('warrant_page_by_time') },
        // { value: 'TYPE', label: i18n.t('warrant_page_by_type') }
    ]
    // 排序
    const sortList = [
        { value: '1', label: i18n.t('general_text_ascending') },
        { value: '-1', label: i18n.t('general_text_descending') }
    ]

    React.useEffect(() => {
        useData.init(props.comType, props.restaurantStringId);
        return () => { };
    }, []);

    return (
        <div className='authorizationManager'>
            <Box  >
                {/* 搜索 */}
                <Box className='table-top-tool'>
                    <Box className={'left-tool'}>
                        {isPatchFlag && <ButtonComponent
                            {...{
                                variant: 'contained',
                                color: 'secondary',
                                size: 'small',
                                extraButtonStyle: 'left-tool-delete-button',
                                titleText: `${i18n.t('general_text_delete')}`,
                                action: 'DELETE',
                                disabled: selectedList.length === 0,
                                handleClick: () => {
                                    useData.updateConfirmDialog({
                                        visible: true,
                                        handleClick: () => useData.deleteWarrantData()
                                    })
                                },
                            }} />}
                        <Button className={'mr8'} variant={'contained'} onClick={() => { useData.updateIsPatchFlag() }}>
                            {i18n.t(isPatchFlag ? 'warrant_page_button_cancel_operation' : 'warrant_page_button_bulk_operation')}
                        </Button>
                        <SearchKeyInput
                            className={'mr8'}
                            items={(comType === 'GROUP' ? searchKeyListGroup : searchKeyListRes) as SearchKeyInputItems[]}
                            conditions={toJS(conditions)}
                            onSearch={(conditions: ConditionType[]) => {
                                useData.setConditions(conditions);
                            }}
                        />
                        {/* 搜索key 2*/}
                        <Box className={'mr8'}>
                            <CommonInput
                                inputType={'SELECT'}
                                items={searchKeySecondList}
                                size={'small'}
                                fullWidth
                                value={searchSecondKey}
                                onChange={(e) => {
                                    useData.updateSearchSecondKey(e.target.value);
                                }}
                            />
                        </Box>
                        {/* 排序 */}
                        <Box className={'mr8'}>
                            <CommonInput
                                inputType={'SELECT'}
                                items={sortList}
                                size={'small'}
                                fullWidth
                                value={searchSort}
                                onChange={(e) => {
                                    useData.updateSearchSort(e.target.value);
                                }}
                            />
                        </Box>
                    </Box>
                    <Box className={'right-tool'}>
                        <CommonInput
                            inputType={'SELECT'}
                            select={true}
                            items={activeWarrantList}
                            size={'small'}
                            fullWidth
                            value={activeType}
                            onChange={(e) => {
                                useData.updateActiveType(e.target.value as ('USE' | 'EXPIRED'));
                            }}
                        />
                        <Box marginLeft={2}>
                            <CommonInput
                                inputType={'SELECT'}
                                select={true}
                                items={viewModeList}
                                size={'small'}
                                label={`${i18n.t('general_text_view_mode')}`}
                                fullWidth
                                value={viewMode}
                                onChange={(e) => {
                                    useData.updateViewMode(e.target.value as ('DETAIL' | 'SUMMARY'));
                                }}
                            />
                        </Box>
                    </Box>
                </Box>
                {/* 搜索条件 */}
                <Box>
                    <ConditionsBox conditions={toJS(conditions)} onDelete={(conditions) => {
                        useData.setConditions(conditions);
                    }} />
                </Box>
                {/* 内容 */}
                <Box>
                    {/* 集团授权 */}
                    {comType === 'GROUP' && <CardView
                        title={
                            <Box display='flex' alignItems='center'>
                                <Typography fontWeight={600} fontSize={'1.25rem'}>
                                    {i18n.t('warrant_page_text_group')}
                                </Typography>
                                <Typography sx={(theme) => { return { color: theme.palette.secondary.main, padding: '0 0.85rem' } }} >
                                    {belongedGroupName}
                                </Typography>
                            </Box>
                        }
                        actionRender={(<ButtonComponent
                            {...{
                                variant: 'contained',
                                titleText: `${i18n.t('general_text_add')}`,
                                action: 'ADD',
                                handleClick: () => {
                                    const operations = {
                                        stringId: useData.belongedGroup,
                                        target: 'GROUP'
                                    }
                                    useData.toggleAuthDialog(true, operations)
                                },
                            }} />)}
                        style={{ marginBottom: '1rem' }}
                        contentRender={(
                            <Grid>
                                <AuthCardGroup
                                    dataList={groupWarrantList || []}
                                    viewMode={viewMode}
                                    showSelectBox={!!isPatchFlag}
                                    selectedList={selectedList}
                                    onClick={(wararntItem) => {
                                        const operation = {
                                            stringId: useData.belongedGroup,
                                            target: 'GROUP'
                                        }
                                        useData.toggleCheck(wararntItem, operation)
                                    }}
                                    showSkeleton={isLoading}
                                />
                            </Grid>
                        )}
                    />}
                    {/* 餐厅授权(集团管理多个 餐厅管理单个) 缺失值时,显示单个 */}
                    {(restuarantWarrantList || [{}])?.map((item, index) => {
                        return (
                            <CardView
                                key={index}
                                title={
                                    <Box display='flex' alignItems='center'>
                                        <Typography fontWeight={600} fontSize={'1.25rem'}>
                                            {i18n.t('warrant_page_text_restaurant')}
                                        </Typography>
                                        <Typography sx={(theme) => { return { color: theme.palette.secondary.main, padding: '0 0.85rem' } }} >
                                            {item?.nickname}
                                        </Typography>
                                    </Box>
                                }
                                actionRender={(<>
                                    {
                                        useData.activeType === 'INACTIVATED' ?
                                            <ButtonComponent
                                                {...{
                                                    variant: 'contained',
                                                    titleText: i18n.t('warrant_page_text_activate'),
                                                    handleClick: async () => {
                                                        const operations = {
                                                            stringId: item.string_id || '',
                                                            target: 'RESTAURANT'
                                                        }
                                                        await useData.toggleActiveDialog(operations);
                                                    },
                                                    children: i18n.t('warrant_page_text_activate'),
                                                    disabled: !item.warrants?.length
                                                }} />
                                            :
                                            <ButtonComponent
                                                {...{
                                                    variant: 'contained',
                                                    titleText: `${i18n.t('warrant_page_text_renewal_of_contract')}`,
                                                    handleClick: async () => {
                                                        const operations = {
                                                            stringId: item.string_id || '',
                                                            target: 'RESTAURANT',
                                                            actionType: 'RENEWAL' as const
                                                        }
                                                        await useData.toggleRenewalDialog(operations);
                                                    },
                                                    children: i18n.t('warrant_page_text_renewal_of_contract'),
                                                    disabled: !item.warrants?.length
                                                }} />
                                    }

                                    <ButtonComponent
                                        {...{
                                            variant: 'contained',
                                            titleText: `${i18n.t('general_text_add')}`,
                                            action: 'ADD',
                                            handleClick: () => {
                                                const operations = {
                                                    stringId: item.string_id || '',
                                                    target: 'RESTAURANT'
                                                }
                                                useData.toggleAuthDialog(true, operations)
                                            },
                                        }} /></>)}
                                style={{ marginBottom: '1rem' }}
                                contentRender={(
                                    <Grid>
                                        <AuthCardGroup
                                            dataList={item?.warrants || []}
                                            viewMode={viewMode}
                                            showSelectBox={!!isPatchFlag}
                                            selectedList={selectedList}
                                            onClick={(wararntItem) => {
                                                const operation = {
                                                    stringId: item.string_id || '',
                                                    target: 'RESTAURANT'
                                                }
                                                useData.toggleCheck(wararntItem, operation)
                                            }}
                                            showSkeleton={isLoading}
                                        />
                                    </Grid>)
                                }
                            />
                        )
                    })}
                </Box>
            </Box>
            {/* 二次确认弹窗 */}
            <DeleteDialog
                {...{
                    open: confirmDialogData.visible,
                    onCancel: () => { confirmDialogData?.onCancel?.(); },
                    onConfirm: () => { confirmDialogData?.handleClick?.(); },
                    title: confirmDialogData.title,
                    desc: confirmDialogData.content,
                }} />
            {/* 选择授权点弹窗 */}
            <AuthPointDialog
                open={authPointDialogData.open}
                onCancel={() => {
                    authPointDialogData.onCancel()
                }}
                operations={authPointDialogData.operations}
                onClick={(selectAuth) => {
                    useData.toggleAuthPointInfoDialog(true, 'ADD', selectAuth)
                }}
            />
            {/* 授权点详情弹窗 */}
            <AuthPointInfoDialog
                open={authPointInfoDialogData.open}
                onCancel={() => {
                    authPointInfoDialogData.onCancel();
                }}
                operations={authPointInfoDialogData.operations}
                onConfirm={() => {
                    useData.getAuthData();
                }}
                type={authPointInfoDialogData.type}
                authInfo={authPointInfoDialogData.selectAuth!}
                belongedGroup={belongedGroup}
            />
        </div>
    )
})

export default AuthorizationManager;

